import { capitalizeFirst } from '@zillow/home-details-formatters';

export function formatCity(value?): string {
    const capitalFirstWords = (value || '')
        .split(' ')
        .map((word) => String(capitalizeFirst(word.toLowerCase())));
    return capitalFirstWords.join(' ');
}
